module.exports = __webpack_public_path__ + "37ba7b92/img/upload-icon.9179ae4e.svg";